package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.detectLanguage
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.LanguageContext
import com.anjuros.website.components.language.LocalLanguage
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.templates.selection.util.Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun PrivacyPolicy() {
    var lang by remember { mutableStateOf(Language.EN) }

    LaunchedEffect(Unit) {
        lang = detectLanguage()
    }

    val languageContext = remember(lang) {
        LanguageContext(
            lang = lang,
            setLang = { lang = it }
        )
    }
    CompositionLocalProvider(LocalLanguage provides languageContext) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .padding(30.px),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.Start
        ) {
            // Title
            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.Black)
                    .fontSize(32.px)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.PRIVACY_POLICY_TITLE))
            }

            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.Black)
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.PRIVACY_POLICY_LAST_UPDATED))
            }

// Section 1
            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.Black)
                    .fontSize(22.px)
                    .fontWeight(FontWeight.SemiBold)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.PRIVACY_POLICY_SECTION1_TITLE))
            }

            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.Black)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.PRIVACY_POLICY_SECTION1_TEXT1))
            }

            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.Black)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.PRIVACY_POLICY_SECTION1_TEXT2))
            }

// Section 2
            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.Black)
                    .fontSize(22.px)
                    .fontWeight(FontWeight.SemiBold)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.PRIVACY_POLICY_SECTION2_TITLE))
            }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION2_BUSINESS)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION2_EMAIL)) }

// Section 3
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(22.px).fontWeight(FontWeight.SemiBold).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION3_TITLE)) }

// 3A
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(20.px).fontWeight(FontWeight.Medium).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION3A_TITLE)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION3A_TEXT1)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION3A_TEXT2)) }

// 3B
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(20.px).fontWeight(FontWeight.Medium).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION3B_TITLE)) }

            P(
                attrs = Modifier
                    .fillMaxWidth()
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.Black)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.PRIVACY_POLICY_SECTION3B_TEXT1))
            }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION3B_TEXT2)) }

// Section 4
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(22.px).fontWeight(FontWeight.SemiBold).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION4_TITLE)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION4_TEXT1)) }

// Section 5
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(22.px).fontWeight(FontWeight.SemiBold).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION5_TITLE)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION5_TEXT1)) }

// Section 6
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(22.px).fontWeight(FontWeight.SemiBold).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION6_TITLE)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION6_TEXT1)) }

// Section 7
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(22.px).fontWeight(FontWeight.SemiBold).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION7_TITLE)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION7_TEXT1)) }

// Section 8
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(22.px).fontWeight(FontWeight.SemiBold).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION8_TITLE)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION8_TEXT1)) }

// Section 9
            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(22.px).fontWeight(FontWeight.SemiBold).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION9_TITLE)) }

            P(
                attrs = Modifier.fontFamily(Constants.FONT_FAMILY).color(Colors.Black)
                    .fontSize(18.px).fontWeight(FontWeight.Normal).toAttrs()
            ) { Text(LocalText(ResKey.PRIVACY_POLICY_SECTION9_TEXT1)) }
        }
    }
}